import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useLanguage } from "@/contexts/LanguageContext";
import { useUsageTracking } from "@/hooks/useUsageTracking";
import { Languages } from "lucide-react";

interface LanguageToggleProps {
  showSwitch?: boolean;
}

const LanguageToggle = ({ showSwitch = false }: LanguageToggleProps) => {
  const { language, toggleLanguage, t } = useLanguage();
  const { logUsage } = useUsageTracking();

  const handleLanguageToggle = () => {
    const newLang = language === 'en' ? 'es' : 'en';
    logUsage('language_selected', { language: newLang });
    toggleLanguage();
  };

  if (showSwitch) {
    return (
      <div className="flex items-center space-x-2">
        <Label htmlFor="language-switch" className="text-sm font-medium">
          {t('selectLanguage')}
        </Label>
        <div className="flex items-center space-x-2">
          <span className={`text-xs ${language === 'en' ? 'font-semibold' : 'text-muted-foreground'}`}>
            {t('english')}
          </span>
          <Switch
            id="language-switch"
            checked={language === 'es'}
            onCheckedChange={() => handleLanguageToggle()}
          />
          <span className={`text-xs ${language === 'es' ? 'font-semibold' : 'text-muted-foreground'}`}>
            {t('spanish')}
          </span>
        </div>
      </div>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleLanguageToggle}
      className="flex items-center gap-2"
    >
      <Languages className="w-4 h-4" />
      {language.toUpperCase()}
    </Button>
  );
};

export default LanguageToggle;